export interface ArticleData {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  author: string;
  imageSeq: string;
  imageQuery: string;
  content: string[];
  relatedSlugs: string[];
  faqs?: { question: string; answer: string }[];
}

export const articleDatabase: Record<string, ArticleData> = {
  "2024-nian-zui-jia-dian-ying-pan-dian": {
    slug: "2024-nian-zui-jia-dian-ying-pan-dian",
    title: "2024年度最佳电影盘点：这些神作你看了几部？",
    excerpt: "回望2024年，华语电影市场涌现出众多口碑佳作。从科幻巨制到文艺小品，从动画电影到现实题材，我们为你精选了年度必看的十部电影。",
    category: "电影资讯",
    date: "2024-12-28",
    readTime: "8分钟",
    author: "芒果编辑",
    imageSeq: "article-detail-01",
    imageQuery: "Film awards ceremony scene, golden trophies on red carpet, warm spotlight lighting, elegant cinema atmosphere, soft bokeh background, sophisticated composition, high detail, 8K quality",
    content: [
      "2024年即将落幕，这一年对于中国电影市场来说是充满惊喜与突破的一年。从春节档的票房井喷到暑期档的口碑爆发，华语电影在类型多样化和工业化水准上都交出了令人满意的答卷。",
      "科幻电影方面，《流浪地球3》以震撼的视觉效果和深刻的人文关怀，将中国科幻推向了新高度。郭帆导演在前两部的基础上进一步拓展了世界观，让观众看到了中国科幻电影的无限可能。影片全球票房突破80亿，成为中国影史票房冠军。",
      "动画电影领域，《哪吒之魔童闹海》以惊人的票房成绩证明了国产动画的市场号召力。饺子导演用七年的时间打磨这部续作，从画面精度到故事深度都有了质的飞跃。影片不仅在票房上取得了巨大成功，更在艺术表现力上获得了业内一致好评。",
      "现实主义题材方面，《热辣滚烫》以女性视角讲述了一个关于自我救赎和成长的励志故事。贾玲导演的第二部作品延续了她对生活细节的敏锐观察，在笑与泪之间找到了完美的平衡。影片引发了广泛的社会讨论，成为年度最具话题性的电影之一。",
      "史诗巨制《封神第二部》在视效和叙事上都实现了突破。乌尔善导演用十余年时间打造的封神宇宙初见雏形，中国神话故事被赋予了全新的时代解读。影片中气势恢宏的战争场面和细腻的情感刻画相得益彰。",
      "此外，《抓娃娃》《年会不能停》等喜剧片为观众带来了纯粹的欢乐，《沙丘2》《奥本海默》等引进片则展现了好莱坞电影工业的顶级水准。2024年无疑是华语电影百花齐放的一年。",
      "展望2025年，我们有理由相信中国电影将继续在多元化的道路上坚定前行。从已经官宣的项目来看，科幻、动画、现实主义等多种类型都将有重量级作品与观众见面。让我们一起期待更多精彩的中国故事在大银幕上绽放。",
    ],
    relatedSlugs: ["fan-hua-wei-shen-me-neng-huo-bian-quan-wang", "guo-man-jue-qi-zhi-lu"],
    faqs: [
      {
        question: "2024年票房最高的华语电影是哪部？",
        answer: "2024年票房最高的华语电影是《哪吒之魔童闹海》，全球累计票房突破120亿人民币，创造了中国动画电影乃至华语电影的票房新纪录。",
      },
      {
        question: "芒果视频能看2024年这些热门电影吗？",
        answer: "芒果视频持续更新最新电影资源，2024年热门电影陆续上线中。您可以在电影分类频道中找到这些影片，享受1080P超清画质的观影体验。",
      },
    ],
  },
  "fan-hua-wei-shen-me-neng-huo-bian-quan-wang": {
    slug: "fan-hua-wei-shen-me-neng-huo-bian-quan-wang",
    title: "《繁花》为什么能火遍全网？深度解析王家卫首部电视剧",
    excerpt: "从筹备六年到播出即爆，《繁花》用极致的视觉美学和深刻的人物刻画，重新定义了国产电视剧的制作水准。",
    category: "剧评",
    date: "2024-12-25",
    readTime: "12分钟",
    author: "芒果编辑",
    imageSeq: "article-detail-02",
    imageQuery: "Shanghai 1990s neon street scene at night, warm amber and gold lighting, nostalgic urban atmosphere, cinematic Wong Kar-wai aesthetics, soft focus, elegant composition, high detail, 8K quality",
    content: [
      "如果要用一个词来形容《繁花》，那一定是'精致'。从第一帧画面开始，观众就能感受到王家卫导演独特的视觉美学——霓虹闪烁的黄河路、流光溢彩的和平饭店、烟雾缭绕的证券交易所，每一个场景都像是一幅精心构图的摄影作品。",
      "作为王家卫的首部电视剧作品，《繁花》在视觉呈现上延续了他标志性的电影质感。大量的特写镜头、精致的灯光设计、考究的色彩搭配，让这部30集的电视剧拥有了不输于院线电影的视觉体验。这种'降维打击'式的制作水准，让习惯了快餐式制作的观众眼前一亮。",
      "故事方面，《繁花》以1990年代的上海为背景，讲述了一群在时代浪潮中浮沉的小人物的命运。胡歌饰演的阿宝从一个默默无闻的年轻人，凭借过人的胆识和商业嗅觉，一步步成为黄河路上炙手可热的'宝总'。这个角色的成长轨迹，某种程度上也是那个激情燃烧年代无数奋斗者的缩影。",
      "马伊琍饰演的玲子是剧中最具张力的女性角色之一。她精明能干，在商场上不输任何男性，但内心深处却有着不为人知的柔软。唐嫣饰演的汪小姐则是另一番风情，她的天真与执着，为这部充满计算与博弈的商战剧增添了一抹温情的色彩。",
      "《繁花》的语言风格也颇具特色。剧中人物说着一口地道的上海话，方言的使用不仅增强了地域真实感，也为角色增添了独特的魅力。金宇澄原著小说中那些充满诗意的文字，被王家卫用影像语言重新诠释，形成了文学作品影视改编的典范。",
      "从市场表现来看，《繁花》在播出期间持续霸占热搜榜，豆瓣评分稳定在8.5分以上，成为2023-2024年度口碑与热度双丰收的现象级作品。它不仅让观众看到了国产剧在艺术表达上的可能性，也为行业树立了一个新的品质标杆。",
      "《繁花》的成功并非偶然。六年筹备、三年拍摄，王家卫用拍电影的耐心和标准去打磨一部电视剧，这种近乎偏执的创作态度，恰恰是当下影视行业最稀缺的品质。正如剧中那句经典台词：'人生不能重新开始，但可以从现在开始改变结局。'《繁花》用它的品质告诉我们，国产剧的未来，值得期待。",
    ],
    relatedSlugs: ["2024-nian-zui-jia-dian-ying-pan-dian", "guo-man-jue-qi-zhi-lu"],
    faqs: [
      {
        question: "《繁花》一共有多少集？",
        answer: "《繁花》共有30集，每集约45分钟，分为普通话版和沪语版两个版本。沪语版因更贴合原著氛围，获得了观众更高的评价。",
      },
      {
        question: "《繁花》在芒果视频可以看吗？",
        answer: "可以！《繁花》普通话版和沪语版均在芒果视频电视剧频道上线，支持1080P超清画质在线观看，流畅不卡顿。",
      },
    ],
  },
  "guo-man-jue-qi-zhi-lu": {
    slug: "guo-man-jue-qi-zhi-lu",
    title: "国漫崛起之路：从《大圣归来》到《哪吒》系列的技术飞跃",
    excerpt: "十年磨一剑，中国动画电影从技术追赶到文化自信，走出了属于自己的独特风格。让我们一起回顾这段辉煌历程。",
    category: "动漫资讯",
    date: "2024-12-20",
    readTime: "10分钟",
    author: "芒果编辑",
    imageSeq: "article-detail-03",
    imageQuery: "Chinese animation evolution concept art, traditional ink painting transitioning to modern 3D rendering, warm golden and vermillion tones, artistic composition, creative visual storytelling, high detail, 8K quality",
    content: [
      "2015年夏天，《西游记之大圣归来》以9.56亿的票房成绩，宣告了中国动画电影的新时代。在此之前，国产动画电影长期被视为'低幼向'的代名词，而《大圣归来》用惊艳的3D视效和成熟的叙事，打破了这一刻板印象。",
      "《大圣归来》的成功为中国动画产业注入了强心剂。资本开始关注这个长期被忽视的领域，人才开始回流，产业链开始完善。更重要的是，它让中国动画人看到了希望——中国故事加上中国技术，是可以做出世界级作品的。",
      "2019年，《哪吒之魔童降世》横空出世。这部由饺子导演历时五年打磨的作品，以50亿的票房成绩刷新了中国动画电影的历史纪录。影片不仅在技术上达到了国际一流水准——精细的面部表情、流畅的动作设计、宏大的特效场面，更在故事层面实现了突破。'我命由我不由天'的精神内核引发了广泛共鸣。",
      "2023年的《长安三万里》则展示了国漫的另一种可能。追光动画用极具中国美学特色的水墨风格，再现了大唐盛世的恢弘气象。影片以高适与李白长达数十年的友谊为主线，将唐诗的意境与动画的表现力完美融合，开创了'新文化'系列动画的先河。",
      "同年的《深海》则代表了国漫在视觉艺术上的一次大胆探索。导演田晓鹏用'粒子水墨'技术创造了一个梦幻般的海底世界，影片在视觉上的先锋性和在故事上的深度，使其成为中国动画在国际电影节上的一张亮丽名片。",
      "2025年，《哪吒之魔童闹海》以120亿的全球票房打破了所有纪录。七年的等待换来了一部在各方面都全面超越前作的作品。影片在人物塑造上更加立体，在世界观构建上更加宏大，在特效呈现上更加震撼。它不仅是中国动画的巅峰之作，也是全球动画电影史上的里程碑。",
      "从技术追赶到文化自信，从学习模仿到自主创新，中国动画电影用十年时间走完了很多国家需要几十年才能走完的路程。当然，我们也要清醒地看到，国漫的整体工业化水平与世界顶尖水平仍有差距，但方向已经明确，道路已经铺就。属于中国动画的黄金时代，才刚刚开始。",
    ],
    relatedSlugs: ["2024-nian-zui-jia-dian-ying-pan-dian", "fan-hua-wei-shen-me-neng-huo-bian-quan-wang"],
    faqs: [
      {
        question: "国漫和日漫有什么区别？",
        answer: "国漫指的是中国原创动漫作品，近年来在3D动画领域取得了显著突破，如《哪吒》《长安三万里》等作品展现了中国传统文化与现代技术的融合。日漫则以2D手绘风格见长，拥有更加成熟的产业链和全球影响力。两者各有特色，都在相互学习和借鉴。",
      },
      {
        question: "芒果视频有哪些国漫可以看？",
        answer: "芒果视频动漫频道收录了大量优质国漫作品，包括《哪吒之魔童降世》《长安三万里》《深海》《白蛇》系列等热门影片，以及众多国产动画剧集，全部支持1080P超清画质在线观看。",
      },
    ],
  },
};